import { Button, type ButtonProps } from '@shared/components';

export default function UpdateQConfigStructureButton(props: Readonly<ButtonProps>) {
  return (
    <Button variant='outlined' color='primary' {...props} sx={{ minWidth: '140px', ...props?.sx }}>
      Save
    </Button>
  );
}
